
import axios from "axios";
// 添加请求拦截器
axios.interceptors.request.use(
    config=> {
        var token = localStorage.getItem("token");
        var uuid = localStorage.getItem('browserId');

        // 在发送请求之前做些什么
        config.headers.device = "web"
        config.headers.packageId = "1"
        config.headers.product = "lz"
        config.headers.channel = "lz_web"
        config.headers.version = "1.1.0"
        config.headers.deviceCode = uuid?uuid:''
        if(token ){
          config.headers['authToken'] = token?token:'';     // authToken
        }
        if(config.authToken){
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        return config
}, error=> {
    // 对请求错误做些什么
    return Promise.reject(error)
});



// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
});

export default axios


/**
 *
 * @param {*} data
 * @returns
 *
 * {
    headers: {
    device: "iOS",
    packageId: "1",
    version: "1.0.0",
    "authToken": this.token,
    "Content-Type": "application/x-www-form-urlencoded",
    },
    transformRequest: [
    function (data) {
        //在请求之前对data传参进行格式转换
        data = qs.stringify(data);
        console.log(data);
        return data;
    },
    ],
    url:this.api+ "/v1/relation/follow",
    method: "post",
    data: {
    actionUid: val.uid,
    },
}
 */



// WEBPACK FOOTER //
// ./src/api/index.js